import type { ReactNode } from 'react'

export const LabScoreCardLoading = ({ title, attribution }: { title: string; attribution?: ReactNode }) => (
  <div className="min-h-64 space-y-5 rounded-2xl border border-white/12 bg-white/6 p-5" aria-busy="true">
    {attribution}
    <p className="text-md font-semibold text-white">{title}</p>
    <div aria-hidden className="space-y-4 motion-safe:animate-pulse">
      <div className="h-5 w-full rounded bg-white/10" />
      <div className="h-5 w-3/4 rounded bg-white/10" />
      <div className="h-5 w-5/6 rounded bg-white/10" />
    </div>
  </div>
)
